(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("_"), require("Vue"));
	else if(typeof define === 'function' && define.amd)
		define(["_", "Vue"], factory);
	else if(typeof exports === 'object')
		exports["safety-evaluation"] = factory(require("_"), require("Vue"));
	else
		root["safety-evaluation"] = factory(root["_"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__60bb__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 